module.exports = __webpack_public_path__ + "img/beione.a6305a34.png";